// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';

@Component({
    selector: 'seo-issues',
    templateUrl: './issues.component.html',
    styleUrls: [],
    standalone: false,
})
export class SeoIssuesComponent implements OnInit {
    pageCount = 0;

    // Issue categories to display
    issueCategories = [
        {
            classification: 'alert',
            category: 'High',
            header: 'High priority',
            subHeader: 'These alerts can make it difficult for search engines to crawl, index and rank pages',
            faIcon: 'fas fa-chart-line text-danger',
            theme: 'danger',
        },
        {
            classification: 'warning',
            category: 'Medium',
            header: 'Medium priority',
            subHeader: 'These warnings can have a negative effect on search engine rankings',
            faIcon: 'fas fa-chart-line text-warning',
            theme: 'warning',
        },
        {
            classification: 'info',
            category: 'Low',
            header: 'Low priority',
            subHeader: 'These errors may have a small impact on your SEO',
            faIcon: 'fas fa-chart-line text-link',
            theme: 'link',
        },
        {
            classification: 'technical',
            category: 'Technical',
            header: 'Technical SEO Issues',
            subHeader: 'These technical issues could be harmful to your SEO',
            faIcon: 'fas fa-chart-line text-info',
            theme: 'info',
        },
    ];

    constructor (private pageRepoService: PageRepoService) {}

    ngOnInit (): void {
        this.setPageCount();
    }

    setPageCount (): void {
        const params: any = {
            page: 1,
            page_size: 1,
            type: 'html',
        };

        this.pageRepoService.getAll(params)
            .then(data => {
                this.pageCount = data.total || 0;
            });
    }
}
